import React, { useState, useEffect } from 'react'
import { Container, Card } from 'react-bootstrap'
import BusquedaCasos from './busqueda-casos'
import DetalleCasos from './detalle-casos'
import { useDispatch, useSelector } from 'react-redux'
import {  
  obtenerComboSituacion,  
  obtenerComboTipoFecha     
} from '../../store/actions/are-busqueda-casos-action'
import { getInfoAnalyticPrevio } from '../../store/actions/consultar-casos-analytic-action';
import { LoadingComponent } from 'recupero-comunes'

const DescargaAnalytic = () => {
  const [data, setData] = useState([])
  
  const agregarFila = (nuevaFila) => {
    setData([...data, nuevaFila])
  }

  const [loading, setLoading]=useState(false)  
  const dispatch = useDispatch()
  
  const infoAnalyticPrevio = useSelector((state) => state.consultarCasosAnalyticReducer.infoAnalyticPrevio);
  
  useEffect(() => {    
    
    if (infoAnalyticPrevio!=undefined) {      
      setData(infoAnalyticPrevio.object)
    }
  }, [infoAnalyticPrevio])

  useEffect(() => {
    setLoading(true)
    let query = Buffer.from(JSON.stringify({concepto: 142})).toString('base64')
    dispatch(obtenerComboTipoFecha(query))
    .then(() => {
      let query = Buffer.from(JSON.stringify({ concepto: 289 })).toString('base64')
      dispatch(obtenerComboSituacion(query))
    })        
    .then(() => {
      dispatch(getInfoAnalyticPrevio())
    })     
    .then(()=>setLoading(false))    
  }, [dispatch])

  return (
    <div>            
    <LoadingComponent show={loading}/>
    <Container>
      <Card className='mt-4'>
        <Card.Body>
          <BusquedaCasos onGenerarArchivo={agregarFila} />
          <DetalleCasos data={data} />
        </Card.Body>
      </Card>
    </Container>
    /</div>
  )
}

export default DescargaAnalytic
